import journals from './journalTypes';
import resume from './resumeTypes';
import coverLetter from './coverLetterTypes';
import aiMockInterviewTypes from './aiMockInterviewTypes';

export default {
  ...journals,
  ...resume,
  ...coverLetter,
  ...aiMockInterviewTypes,
  DOCUMENT: {
    name: 'Document',
    type: 'Document',
    id: 'Document',
    templateId: 'DOCUMENT',
  },
  CAREER_FINANCIALS: {
    name: 'Career Financials',
    type: 'Career Financials',
    id: 'Career Financials',
    templateId: 'Career Financials',
  },
};
